export default "__VITE_ASSET__CTnR7zlC__"